import routes from '../../assets/constants/routes-no.ts';

export const ARTICLES_INDEX_PATH = routes.ARTICLES;

export const getArticleTagPath = (tag: string) => `${ARTICLES_INDEX_PATH}/${tag}`;

export const formatArticleTagLabel = (tag: string) =>
  tag
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
